import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Percent, RefreshCw, Wrench, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";

export const B2B_REG = "/registrati?tipo=b2b";

const PERKS = [
  { icon: Percent, text: "Prezzi riservati HoReCa su fusti e granite" },
  { icon: Wrench, text: "Spillatori e granitori in comodato d'uso gratuito" },
  { icon: RefreshCw, text: "Riordino rapido e storico dei prezzi pagati" },
];

export function B2BUnlockDialog({ open, onOpenChange }) {
  const navigate = useNavigate();
  const go = () => {
    onOpenChange(false);
    toast.info("Registrati come operatore per vedere i prezzi");
    navigate(B2B_REG);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="b2b-unlock-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[#0B2A45] flex items-center gap-2">
            <Lock className="w-5 h-5 text-[#C2593F]" /> Sblocca il listino operatori
          </DialogTitle>
          <DialogDescription>Registrazione gratuita con Partita IVA, accesso immediato ai prezzi riservati.</DialogDescription>
        </DialogHeader>
        <ul className="space-y-3 my-2">
          {PERKS.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-start gap-3 text-sm text-stone-700">
              <span className="w-8 h-8 rounded-full bg-[#EFF6FF] flex items-center justify-center shrink-0"><Icon className="w-4 h-4 text-[#0F4C81]" /></span>
              <span className="pt-1.5">{text}</span>
            </li>
          ))}
        </ul>
        <Button onClick={go} className="w-full bg-[#0F4C81] hover:bg-[#0B2A45] rounded-full h-11" data-testid="b2b-unlock-register-btn">
          Registrati con Partita IVA <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </DialogContent>
    </Dialog>
  );
}

export default function BlurredPrice({ label, masked, note, testId }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="text-left group/price" data-testid={testId}>
        <div className="text-[0.65rem] uppercase tracking-wider text-stone-400">{label}</div>
        <div className="relative inline-block">
          <div className="font-mono font-bold text-lg text-[#0F4C81] blur-[5px] select-none" aria-hidden="true">{masked}</div>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="inline-flex items-center gap-1 text-[0.65rem] font-semibold uppercase tracking-wider bg-white/90 text-[#C2593F] px-2 py-0.5 rounded-full border border-[#C2593F]/30 group-hover/price:bg-[#C2593F] group-hover/price:text-white transition-colors">
              <Lock className="w-3 h-3" /> Sblocca
            </span>
          </div>
        </div>
        {note && <div className="text-[0.7rem] text-stone-400 mt-0.5">{note}</div>}
      </button>
      <B2BUnlockDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
